<template>
  <div class="home">
    <my-header :current-year="currentYear" />
    <div class="calc-continer">
      <div id="year-calendar">
        <transition :name="currentSlide" mode="out-in">
          <router-view
            :increase-year="increaseYear"
            :decrease-year="decreaseYear"
            :key="currentYear"
          />
        </transition>
      </div>
    </div>
    <my-footer />
  </div>
</template>

<script>
import HeaderVue from "./Header.vue";
import FooterVue from "../../common/Footer.vue";
import { authMixin } from "../../../mixins/authMixin.js";

export default {
  mixins: [authMixin],
  data() {
    return {
      currentSlide: "slide-right"
    };
  },
  methods: {
    decreaseYear() {
      this.currentSlide = "slide-right";
      this.$router.push("/year/" + (this.currentYear - 1));
    },
    increaseYear() {
      this.currentSlide = "slide-left";
      this.$router.push("/year/" + (this.currentYear + 1));
    }
  },
  components: {
    myHeader: HeaderVue,
    myFooter: FooterVue
  },
  computed: {
    currentYear() {
      if (isNaN(this.$route.params.year)) {
        return 2019;
      } else {
        return parseInt(this.$route.params.year);
      }
    }
  }
};
</script>

<style scoped>
.home {
  margin-top: 94px;
}

div {
  overflow: hidden !important;
}

.months-wrapper {
  display: flex !important;
  flex-wrap: wrap;
}

/* stage 2. Entered */
.slide-right-enter-active {
  animation: slide-in-right 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.slide-right-leave-active {
  animation: slide-out-right 0.2s ease-in-out forwards;
}

.slide-right-move {
  transition: transform 0.2s ease-in-out;
}

.slide-left-enter-active {
  animation: slide-in-left 0.2s ease-in-out forwards;
}

/* stage 3. leave */
.slide-left-leave-active {
  animation: slide-out-left 0.2s ease-in-out forwards;
}

.slide-left-move {
  transition: transform 0.2s ease-in-out;
}

@keyframes slide-in-right {
  from {
    transform: translateX(-20%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out-right {
  from {
    transform: translateX(0px);
    opacity: 1;
  }
  to {
    transform: translateX(20%);
    opacity: 0;
  }
}

@keyframes slide-in-left {
  from {
    transform: translateX(20%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out-left {
  from {
    transform: translateX(0px);
    opacity: 1;
  }
  to {
    transform: translateX(-20%);
    opacity: 0;
  }
}
</style>
